import * as Yup from 'yup';
import { useTranslation } from '../../../hooks/useTranslation';

type TFunction = ReturnType<typeof useTranslation>['t'];

export const REJECT_SCHEMA = (t: TFunction) => {
    return Yup.object().shape({
        rejectReason: Yup.string().max(250, t('validationMessages.REJECT_SCHEMA.rejectReason.max')),
    });
};
